/*
 * @Description: x-charts 模块暴露接口
 * @Author: pdeng
 * @Date: 2019-10-16 19:54:06
 * @LastEditTime: 2019-10-17 10:10:36
 * @LastEditors: Please set LastEditors
 */
import Xcharts from './core'
export { Xcharts }
